import React, { useState } from 'react'

import { VideoModal } from './VideoModal' // same folder import

interface VideoPlayerProps {
  thumbnail: string
  url: string
  showControls?: boolean
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({ thumbnail, url, showControls }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <img
        src={thumbnail}
        alt="Video Thumbnail"
        className="cursor-pointer w-full video-player-image"
        onClick={() => setOpen(true)}
      />

      <VideoModal isOpen={open} onClose={() => setOpen(false)} url={url} showControls={showControls} />
    </>
  )
}
